import { getJournalLedger } from "@/api/finance/reportApi";
import {
  getJournalLedgerRows,
  getJournalLedgerColumns,
} from "./journal-ledger-statement";
import { DynamicReport } from "@/components/dynamic";

const journalLedgerFilters = {
  AccountCode: "*",
  // Component: "*"
};

const journalLedgerFilterOptions = [
  { key: "accountCode", apiKey: "AccountCode" },
  { key: "costCenters", apiKey: "Component" }
];

function ReportJournalLedger({ activeCompany }) {
  const customFetchFunction = (params) => getJournalLedger({
    scope: "leasing",
    startDate: params.StartDate,
    endDate: params.EndDate,
    companyId: params.companyId,
    "filters.accountCode": params.AccountCode,
    "filters.costCenters": params.Component
  });

  return (
    <DynamicReport
      reportName="journal-ledger"
      activeCompany={activeCompany}
      columnsDataProvider={getJournalLedgerColumns(activeCompany)}
      rowsDataProvider={getJournalLedgerRows}
      fetchData={customFetchFunction}
      exportUrl="finance/reports/journal-ledger/xls"
      filtersInitialState={journalLedgerFilters}
      filterOptions={journalLedgerFilterOptions}
      orderBy="Company"
      showDateRangeFilter
      isPaginated
      showLoadReportButton
      startDate={null}
      endDate={null}
      searchPlaceholder="Search by name, cost center, account, account code"
    />
  );
}

export default ReportJournalLedger;
